import * as React from 'react';
import { FC } from 'react';
import InfiniteScroll from 'app/helpers/InfiniteScroll';
import { COLUMN_CLASSES, SectionProps } from './section';
import type { Game } from './types';
import GameComponent from './Game';

const arePaginated = (props: SectionProps) => props.paginatedGames.meta.total_pages > 1;

const Grid: FC<Omit<SectionProps, 'paginatedGames'> & { games: Game[] }> = ({
  gameStarter,
  games,
  common,
  labelId,
}) => (
  <div className={`games_list section__grid ${COLUMN_CLASSES[common.columns]}`} aria-labelledby={labelId}>
    {games.map((game) => (
      <GameComponent key={game.id} gameStarter={gameStarter} game={game} common={common} />
    ))}
  </div>
);

const PaginadedGrid: FC<SectionProps> = (props) => (
  <InfiniteScroll<Game> initialItems={props.paginatedGames}>
    {(currentGames) => <Grid {...{ ...props, games: currentGames }} />}
  </InfiniteScroll>
);

const SectionGrid: FC<SectionProps> = (props) =>
  arePaginated(props) ? <PaginadedGrid {...props} /> : <Grid {...{ ...props, games: props.paginatedGames.data }} />;

export default SectionGrid;
